var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.contMenuOpened(),
          expression: "contMenuOpened()",
        },
      ],
      staticClass: "overlay-back",
      on: {
        click: function ($event) {
          return _vm.closeContMenu()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "cont-menu" },
        [
          _c("div", {
            staticClass: "x-icon icon close",
            on: {
              click: function ($event) {
                return _vm.closeContMenu()
              },
            },
          }),
          _c("LoginComponentHomePage"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }